import {users} from '@mep/pae-commons';
import React from 'react';

import {MunicipalityEnumComponent, ValueMunicipalityEnumComponent} from '@/components/MunicipalityEnumComponent';
import {ProvinceEnumFilterComponent, ProvinceValueEnumFilterComponent} from '@/components/ProvinceEnumFilterComponent';
import {UserFilterProposal, ValueFilterProposal} from '@/modules/admin/components/UserFilterProposal';
import {UserFilterStatus, ValueUserState} from '@/modules/admin/components/UserFilterStatus';
import {UserRepresentativeFilter} from '@/modules/admin/components/UserRepresentativeFilter';
import {handleSocialDenomination} from '@/modules/proposalRequest/hooks/useSocialDenominationType';
import {authentication, i18n} from '@/settings';

const {USER_TYPES_ENUM, USER_ACCESS_LEVELS_ENUM} = users;

export const filters = [
  {
    name: 'user.userType',
    type: 'enum',
    field: 'userType',
    options: USER_TYPES_ENUM.map(e => ({label: `user.types.${e}`, value: e}))
  },
  {
    name: 'accessLevel.label',
    type: 'enum',
    field: 'level',
    options: USER_ACCESS_LEVELS_ENUM.map(e => ({label: `accessLevel.${e}`, value: e}))
  },
  {
    name: 'status',
    // eslint-disable-next-line react/prop-types,react/display-name
    render: ({...props}) => <UserFilterStatus {...props}/>,
    // eslint-disable-next-line react/display-name,react/prop-types
    renderValue: ({...props}) => <ValueUserState {...props}/>,
  },
  {
    name: 'user.filters.isRepresentative',
    field: 'isRepresentative.active',
    type: 'bool',
    // eslint-disable-next-line react/display-name
    render: ({...props}) => <UserRepresentativeFilter {...props}/>,
    trueText: 'user.filters.representative',
    falseText: 'user.filters.partner',
  },
  {
    name: 'roles',
    type: 'dynamic',
    objectId: true,
    request: `${authentication.path}/api/security/roles/search`,
    field: 'roles.role',
    labelKey: (item) => {
      const exist = i18n.exists(`admin:rol.${item?.name}`);
      return exist ? i18n.t(`admin:rol.${item?.name}`) : item?.name;
    },
  },
  {
    name: 'user.filters.proposal',
    request: `${authentication.path}/api/proposal-requests/searchReduced`,
    field: 'lastProposal',
    labelKey: handleSocialDenomination,
    // eslint-disable-next-line react/prop-types,react/display-name
    render: ({...props}) => <UserFilterProposal {...props}/>,
    // eslint-disable-next-line react/prop-types,react/display-name
    renderValue: ({filterValue, t, filter}) => <ValueFilterProposal filter={filter} t={t} filterValue={filterValue}/>,
  },
  {
    name: 'user.filters.hasOffice',
    field: 'metadata.office',
    type: 'exist',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'user.filters.notaryOffice',
    type: 'dynamic',
    request: `${authentication.path}/api/notary-offices/search`,
    field: 'metadata.office',
    labelKey: (item) => `(${item.code}) ${item.name}`,
  },
  {
    name: 'user.filters.dpjOffice',
    type: 'dynamic',
    request: `${authentication.path}/api/dpjs/search`,
    field: 'metadata.office',
    labelKey: (item) => `(${item.code}) ${item.name}`,
  },
  {
    name: 'user.filters.commercialRegisters',
    type: 'dynamic',
    request: `${authentication.path}/api/commercial-registers/search`,
    field: 'metadata.office',
    labelKey: (item) => `(${item.code}) ${item.name}`,
  },
  {
    name: 'user.filters.historianOffice',
    type: 'dynamic',
    request: `${authentication.path}/api/historian-offices/search`,
    field: 'metadata.office',
    labelKey: 'name',
  },
  {
    name: 'provinces',
    field: 'address.province',
    // eslint-disable-next-line react/display-name
    render: (props) => <ProvinceEnumFilterComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ProvinceValueEnumFilterComponent {...props}/>
  },
  {
    name: 'municipalities',
    search: true,
    type: 'enum',
    field: 'address.municipality',
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ValueMunicipalityEnumComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    render: (props) => <MunicipalityEnumComponent {...props}/>
  },
  {
    name: 'user.filters.createdAt',
    field: 'createdAt',
    type: 'dateRange',
  },
  {
    name: 'user.filters.lastLoginAt',
    field: 'lastLoginAt',
    type: 'dateRange',
  }
];

export const usersFilters = filters.filter((colum) => !colum.field || !colum.field.match(/level|userType|metadata\.office/));
